import { Feature } from "geojson";
import * as L from "leaflet";
import "../../libs/leaflet.pattern";
import "../../libs/leaflet.textpath";
import "../../libs/svg.icon";
import ILayerStyle from "./ILayerStyle";

export default class DefaultStyle implements ILayerStyle {
    private pane?: string;
    private interactive: boolean;

    constructor({pane, interactive} : {interactive: boolean, pane?: string}) {
        this.pane = pane;
        this.interactive = interactive;
    }

    public getOptions = (): L.GeoJSONOptions => {
        return {
            pane: this.pane,
            pointToLayer: (feature: Feature, latlng: L.LatLng) => {
                const layer = L.circleMarker(latlng, {
                    color: "red",
                    interactive: this.interactive,
                    radius: 3,
                    pane: this.pane,
                });
                (layer as any).feature = feature;
                return layer;
            },
            style: () => {
                return {
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 0.4,
                    interactive: this.interactive,
                };
            },
        }
    };
}
